export default {
  api_r_user_userQuery_list: {
    path: 'user-query/list/',
  },
  api_r_user_userQuery_add: {
    path: 'user-query/add/',
  },
  api_r_user_userQuery_messages: {
    path: 'user-query/messages/',
  },
  api_r_user_userQuery_messages_file_download: {
    path: 'user-query/messages/file/download/',
  },
  api_r_user_userQuery_messages_set: {
    path: 'user-query/messages/set/',
  },
  api_r_user_userQuery_messages_score_set: {
    path: 'user-query/messages/score/set/',
  },
};
